import { render, staticRenderFns } from "./SignModal.vue?vue&type=template&id=f2b352e8&"
import script from "./SignModal.vue?vue&type=script&lang=js&"
export * from "./SignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports